/*
 * Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
 */

import VueI18n from "vue-i18n";
import en from "./translations/en";
import cs from "./translations/cs";

const DEFAULT_LOCALE = "en";

const messages = {
  en,
  cs
};

export default new VueI18n({
  locale: DEFAULT_LOCALE,
  messages
});
